

































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {}
})
export default class Topics extends Vue {
    public input: string = "";

    get topicsSearch() {
        if (this.input.length > 2) return this.$mulinoApi.getTopics(this.input);
        return new Promise(resolve => resolve(""));
    }

    @Prop() value;
    @Prop() error;

    public removeTopic(index) {
        this.value.splice(index, 1);
    }

    public addTopic(topic) {
        this.value.push(topic);
        this.input = "";
    }
}
